import * as React from "react";
import { observer } from "mobx-react";
import { WizardHotelPWAv2Props } from "./typings";
import { LobTitle } from "src/components/shared/LobTitle/LobTitle";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { Travelers } from "src/components/shared/Travelers/Travelers";
import { SubmitButton } from "src/components/shared/SubmitButton/SubmitButton";
import { HotelAddFlightCheckbox } from "components/flexComponents/WizardHotelPWAv2/components/HotelAddFlightCheckbox";
import { HotelAddCarCheckbox } from "components/flexComponents/WizardHotelPWAv2/components/HotelAddCarCheckbox";
import { HotelHiddenSearchData } from "./components/HotelHiddenSearchData";
import { UitkLayoutGrid, UitkLayoutGridSpan } from "uitk-react-layout-grid";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { HotelTabs } from "components/flexComponents/WizardHotelPWAv2/components/HotelTabs";

export const WizardHotelPWAv2View: React.FunctionComponent<WizardHotelPWAv2Props> = observer((props) => {
  const {
    hotelWizardState,
    hotelWizardState: { config: hotelConfig },
  } = props.wizardState;
  const locationColSpan = {
    small: 2 as UitkLayoutGridSpan,
    medium: 4 as UitkLayoutGridSpan,
    large: 2 as UitkLayoutGridSpan,
  };
  const datesColSpan = { small: 2 as UitkLayoutGridSpan, medium: 2 as UitkLayoutGridSpan };
  const travelersColSpan = { small: 2 as UitkLayoutGridSpan, medium: 1 as UitkLayoutGridSpan };
  const submitColSpan = { small: 2 as UitkLayoutGridSpan, medium: 1 as UitkLayoutGridSpan };

  return (
    <form
      noValidate={true}
      className="WizardHotelPWAv2"
      id={hotelConfig.elementId}
      data-fm={props.flexComponent.fmId}
      data-fm-title-id={props.flexComponent.fmTitleId}
      onSubmit={hotelWizardState.submit}
      action={hotelWizardState.formAction}
    >
      <LobTitle lobState={hotelWizardState} />
      <HotelTabs hotelWizardState={hotelWizardState} />
      <UitkLayoutGrid columns={{ small: 2, medium: 4, large: 6 }} space="three" className="all-t-margin-two">
        <Location originField={false} destinationField={true} lobState={hotelWizardState} colSpan={locationColSpan} />
        <Dates lobState={hotelWizardState} colSpan={datesColSpan} />
        <Travelers lobState={hotelWizardState} colSpan={travelersColSpan} />
        <SubmitButton lobState={hotelWizardState} colSpan={submitColSpan} />
      </UitkLayoutGrid>
      {(hotelWizardState.config.enableAddFlight || hotelWizardState.config.enableAddCar) && (
        <UitkLayoutFlex space="three" className="all-t-padding-two">
          {hotelWizardState.config.enableAddFlight && <HotelAddFlightCheckbox hotelWizardState={hotelWizardState} />}
          {hotelWizardState.config.enableAddCar && <HotelAddCarCheckbox hotelWizardState={hotelWizardState} />}
        </UitkLayoutFlex>
      )}
      {hotelWizardState.isAddAFlightChecked && (
        <UitkLayoutGrid columns={{ small: 2, medium: 4, large: 6 }} space="three" className="all-t-margin-one">
          <Location originField={true} destinationField={false} lobState={hotelWizardState} colSpan={locationColSpan} />
        </UitkLayoutGrid>
      )}
      <HotelHiddenSearchData hotelWizardState={hotelWizardState} />
    </form>
  );
});

export default WizardHotelPWAv2View;
